/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Lasso = [
  ["path", { d: "M3.704 14.467a10 8 0 1 1 3.115 2.375" }],
  ["path", { d: "M7 22a5 5 0 0 1-2-3.994" }],
  ["circle", { cx: "5", cy: "16", r: "2" }]
];

export { Lasso as default };
//# sourceMappingURL=lasso.js.map
